'use client'
import GoldLinkButton from '@/components/GoldLinkButton'
import { useMessages, useTranslations } from 'next-intl'
import Image from 'next/image'
import { useState } from 'react'

const eventsImages = {
  1: 'https://storage.googleapis.com/rolzo-static-bucket/images/Events/case-study/case-study-1.jpg',
  2: 'https://storage.googleapis.com/rolzo-static-bucket/images/Events/case-study/case-study-2.jpg',
  3: 'https://storage.googleapis.com/rolzo-static-bucket/images/Events/case-study/case-study-3.png',
  4: 'https://storage.googleapis.com/rolzo-static-bucket/images/Events/case-study/case-study-4.jpg',
  5: 'https://storage.googleapis.com/rolzo-static-bucket/images/Events/case-study/case-study-5.jpg',
  6: 'https://storage.googleapis.com/rolzo-static-bucket/images/Events/case-study/case-study-6.jpg',
  7: 'https://storage.googleapis.com/rolzo-static-bucket/images/Events/case-study/case-study-7.png',
  8: 'https://storage.googleapis.com/rolzo-static-bucket/images/Events/case-study/case-study-8.png',
  9: 'https://storage.googleapis.com/rolzo-static-bucket/images/Events/case-study/case-study-9.png',
  10: 'https://storage.googleapis.com/rolzo-static-bucket/images/Events/case-study/case-study-10.png',
}

const EventsShowCaseSec = () => {
  const [visibleEvents, setVisibleEvents] = useState(6)
  const t = useTranslations('events')
  const handleShowMoreEvents = () => {
    setVisibleEvents((prev) => prev + 4)
  }
  const messages = useMessages()
  const events = Object.keys(messages.events.eventsShowCase.events)
  return (
    <section>
      <div className='container py-12'>
        <div className='md:text-center mb-12'>
          <h5 className='font-normal text-[18px] md:text-[16px] mb-6'>
            {t('eventsShowCase.title')}
          </h5>
          <h3 className='text-[30px] md:text-[28px] font-light mb-6'>
            {t('eventsShowCase.subTitle')}
          </h3>
          <p className='text-[18px] mx-auto md:text-[16px] font-light leading-[1.6] max-w-[560px]'>
            {t('eventsShowCase.description')}
          </p>
        </div>
        <div className='grid grid-cols-1 md:grid-cols-3 gap-x-[30px] gap-y-6 mb-6'>
          {events.slice(0, visibleEvents).map((event) => {
            let query = {}
            if (t.has(`eventsShowCase.events.${event}.href`))
              query = { eventId: t(`eventsShowCase.events.${event}.id`) }
            return (
              <div key={event} className=''>
                <Image
                  src={eventsImages[event]}
                  alt=''
                  width={350}
                  height={233}
                  className='max-w-full h-auto mb-4'
                />
                <h5 className='font-normal text-[18px] md:text-[16px] mb-2'>
                  {t(`eventsShowCase.events.${event}.title`)}
                </h5>
                <p className={`text-[18px] md:text-[16px] leading-[1.6]`}>
                  {t(`eventsShowCase.events.${event}.description`)}
                </p>
                {t.has(`eventsShowCase.events.${event}.href`) && (
                  <GoldLinkButton
                    text='View event'
                    href={t(`eventsShowCase.events.${event}.href`)}
                    query={query}
                  />
                )}
              </div>
            )
          })}
        </div>
        {visibleEvents <= 6 && (
          <div className='flex items-center md:justify-center'>
            <GoldLinkButton
              hasGoldBackground
              hasDownArrow
              type='button'
              text='Load more'
              className='leading-[1.5] py-[6px]'
              onClick={handleShowMoreEvents}
            />
          </div>
        )}
      </div>
    </section>
  )
}

export default EventsShowCaseSec
